<template>
  <div class="container-fluid p-0">
    <div class="loginBackgroundImage" style="min-height: 100vh; height: auto">
      <!-- <div class="heading">fiifi</div> -->
      <div class="row m-0 p-0" style="width: 100%; padding-top: 30px">
        <div
          class="row mr-0 ml-0 d-flex justify-content-center w-100"
          style="margin-top: 60px; margin-bottom: 30px"
        >
          <div class="heading">fiifi</div>
        </div>
        <!-- <div
          class="col-xl-8 col-lg-7 col-md-6 d-sm-none d-none d-md-block bckGrdImg default-transition"
        ></div>-->
        <!-- <div class="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 default-transition"> -->
        <div class="col-12 d-flex justify-content-center align-items-center">
          <div class="loginPopup">
            <div class="loginPopupLayout">
              <div class="loginTitle">Login</div>
              <div class="loginCaption">
                Welcome Back. Don't miss your next opportunity. Login to stay
                updated on your portfolio.
              </div>
              <b-alert
                :show="message.length > 0 ? true : false"
                :variant="variant"
                dismissible
                @dismissed="message = ''"
                >{{ message }}</b-alert
              >
              <div>
                <form
                  autocomplete="off"
                  @submit.prevent="loginCognito"
                  style="margin-bottom: 37px"
                >
                  <span
                    class="forgtTxt"
                    style="float: left; padding-bottom: 5px"
                    >Email/Username</span
                  >
                  <input
                    type="text"
                    class="form-control emailWrapper inputLoginWrapper"
                    v-model="loginForm.email"
                    autocomplete="off"
                    required
                    placeholder="Enter Email/Username"
                    @keyup="checkValidations"
                  />
                  <span
                    class="forgtTxt"
                    style="float: left; padding-bottom: 5px"
                    >Password</span
                  >
                  <input
                    type="password"
                    class="form-control inputGapCls inputLoginWrapper"
                    v-model="loginForm.pswd"
                    style="margin-bottom: 20px"
                    required
                    placeholder="Enter Password"
                    @keyup="checkValidations"
                  />
                  <div class="d-flex">
                    <div class="LoginForgotPassWord flex-grow-1">
                      <a href="#/forgot-password">Forgot Password?</a>
                    </div>
                    <div>
                      <button
                        :disabled="isSubmit"
                        type="submit"
                        class="todo-form-submit-button btn btn-primary mb-0"
                      >
                        Login
                        <b-spinner
                          v-if="showSpinner"
                          style="float: right"
                          small
                          label="Loading..."
                        ></b-spinner>
                      </button>
                    </div>
                  </div>
                </form>
                <div class="loginAboveIconsText">Or you can Login with</div>
                <div
                  class="d-flex justify-content-center"
                  style="margin-top: 17px"
                >
                  <div style="margin-right: 17px; margin-top: 3px">
                    <a :href="googleUrl">
                      <img src="static/img/google-icon.png" class />
                    </a>
                  </div>
                  <div style="margin-right: 17px">
                    <a :href="linkedinUrl">
                      <img src="static/img/link-icon.png" class />
                    </a>
                  </div>
                  <div style="margin-right: 17px">
                    <a :href="twitterUrl">
                      <img src="static/img/twitter-icon.png" class />
                    </a>
                  </div>
                  <div class="ltseBtnDiv">
                    <a :href="ltseUrl">
                      <img src="static/img/ltse.png" class="suggestImage" />
                    </a>
                  </div>
                </div>
                <div style="margin-top: 17px">
                  <div class="newToFiifi">
                    New to fiifi?
                    <span
                      style="color: #5445f3; cursor: pointer"
                      @click="signup"
                      >Sign Up</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="trnsCls">
            <h3 class="wlcmTxt">Welcome Back</h3>
            <p
              class="tag"
            >Don't miss your next opportunity.Sign in to stay updated on your portfolio.</p>
            <b-alert
              :show="message.length>0?true:false"
              :variant="variant"
              dismissible
              @dismissed="message=''"
            >{{message}}</b-alert>
            <form autocomplete="off" @submit.prevent="loginCognito">
              <span class="forgtTxt" style="float:left;">Email/Username</span>
              <input
                type="text"
                class="form-control inputGapCls"
                v-model="loginForm.email"
                autocomplete="off"
                required
                placeholder="Enter Email/Username"
              />
              <span>
                <span class="forgtTxt" style="float:left;">Password</span>
                <a style="cursor:pointer" href="#/forgot-password">
                  <span class="forgtTxt" style="float:right; color:#5445F3;">Forgot Password?</span>
                </a>
              </span>
              <input
                type="password"
                class="form-control inputGapCls"
                v-model="loginForm.pswd"
                required
                placeholder="Enter password"
              />
              <p style="margin-top: 10px;"></p>
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <button
                    :disabled="isSubmit"
                    type="submit"
                    class="lgnBtn todo-form-submit-button btn btn-primary mb-0"
                  >
                    Login
                    <b-spinner v-if="isSubmit" style="float: right;" small label="Loading..."></b-spinner>
                  </button>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <button @click="signup" type="button" class="crtAcntBtn">Sign Up</button>
                </div>
              </div>
              <div class="row">
                <span style="margin-left:6%;margin-top:3%">Or Continue with</span>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12">
                  <a :href="googleUrl">
                    <img src="static/img/google-icon.png" class="lgnIcns" />
                  </a>
                  <a :href="linkedinUrl">
                    <img src="static/img/link-icon.png" class="lgnIcns" />
                  </a>
                  <a :href="twitterUrl">
                    <img src="static/img/twitter-icon.png" class="lgnIcns" />
                  </a>
                </div>
              </div>
            </form>
          </div>-->
        </div>
        <!-- <div class="col-sm-5 col-0"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import NotificationSample from "../Components/NotificationSample";
import {
  Checkbox as LCheckbox,
  FadeRenderTransition,
} from "src/components/index";
import { mapGetters } from "vuex";
import { Dialog } from "element-ui";
import AuthLayout from "./AuthLayout.vue";
import config from "../../../../config/settings";
import util from "util";
import swal from "sweetalert2";
import _ from "lodash";
import api from "../../../axios_api";
import Axios from "axios";
const stringify = JSON.stringify;
export default {
  components: {
    [Dialog.name]: Dialog,
    LCheckbox,
    // FadeRenderTransition,
    AuthLayout,
  },
  computed: {
    ...mapGetters("user", ["token", "user"]),
  },
  data() {
    return {
      modals: {
        custom: false,
        dataimport: false,
      },
      luser: {
        email: "",
        password: "",
      },
      variant: "",
      isSubmit: true,
      message: "",
      loginForm: {},
      facebookUrl: "",
      googleUrl: "",
      twitterUrl: "",
      linkedinUrl: "",
      flagRequestOnce: false,
      showSpinner: false,
      ltseUrl: "",
    };
  },
  mounted() {
    const titleEl = document.querySelector("head title");
    let query = this.$route.query;
    titleEl.textContent = `Fiifi | Login`;
    if (this.$route.query.verification) {
      this.$toaster.success("Verified Successfully.");
      this.$router.push(`/login`);
    }
    if (this.$route.query.per) {
      if (window.localStorage.getItem("fiifi")) {
        let fiifi = window.localStorage.getItem("fiifi");
        fiifi = JSON.parse(fiifi);
        if (fiifi.user.id && fiifi.user.id.length > 0) {
          window.localStorage.setItem(
            "share-portfolio-permalink",
            this.$route.query.per
          );
          if (this.$route.query.a) {
            window.localStorage.setItem(
              "share-portfolio-referred",
              this.$route.query.a
            );
          }
          if(this.$route.query.c){
            window.localStorage.setItem("share-portfolio-checklists", this.$route.query.c);
          }
          this.$store
            .dispatch("accountPlans/getAccountPlanFeatures")
            .then((plans) => {
              this.$store
                .dispatch("workspace/apiFetchworkspaces")
                .then((data) => {
                  if (window.localStorage.getItem("share-portfolio-referred")) {
                    this.$router.push(
                      `${
                        fiifi.user.id
                      }/shared/company?permalink=${window.localStorage.getItem(
                        "share-portfolio-permalink"
                      )}&back=workspace&a=${window.localStorage.getItem(
                        "share-portfolio-referred"
                      )}&c=${window.localStorage.getItem("share-portfolio-checklists")}`
                    );
                  } else {
                    this.$router.push(
                      `${
                        fiifi.user.id
                      }/shared/company?permalink=${window.localStorage.getItem(
                        "share-portfolio-permalink"
                      )}&back=workspace"
                      )}`
                    );
                  }
                });
            });
        } else {
          window.localStorage.setItem(
            "share-portfolio-permalink",
            this.$route.query.per
          );
          if (this.$route.query.a) {
            window.localStorage.setItem(
              "share-portfolio-referred",
              this.$route.query.a
            );
          }
          if(this.$route.query.c){
            window.localStorage.setItem("share-portfolio-checklists", this.$route.query.c);
          }
          this.$router.push(`/login`);
        }
      } else {
        window.localStorage.setItem(
          "share-portfolio-permalink",
          this.$route.query.per
        );
        if (this.$route.query.a) {
            window.localStorage.setItem(
              "share-portfolio-referred",
              this.$route.query.a
            );
          }
          if(this.$route.query.c){
            window.localStorage.setItem("share-portfolio-checklists", this.$route.query.c);
          }
        this.$router.push(`/login`);
      }
    }
    if (this.$route.query.plan) {
      if (window.localStorage.getItem("fiifi")) {
        let fiifi = window.localStorage.getItem("fiifi");
        fiifi = JSON.parse(fiifi);
        if (fiifi.user.id && fiifi.user.id.length > 0) {
          window.localStorage.setItem("plan", this.$route.query.plan);
          this.$store
            .dispatch("accountPlans/getAccountPlanFeatures")
            .then((plans) => {
              this.$router.push(
                `${fiifi.user.id}/payments?plan=${window.localStorage.getItem(
                  "plan"
                )}`
              );
            });
        } else {
          window.localStorage.setItem("plan", this.$route.query.plan);
          this.$router.push(`/login`);
        }
      } else {
        window.localStorage.setItem("plan", this.$route.query.plan);
        this.$router.push(`/login`);
      }
    }
    if (
      query.t &&
      query.t.length > 0 &&
      query.a &&
      query.a.length > 0 &&
      query.w &&
      query.w.length > 0
    ) {
      window.localStorage.setItem(
        "todoEmailPreferencesCheck",
        JSON.stringify({
          t: this.$route.query.t,
          w: this.$route.query.w,
          a: this.$route.query.a,
        })
      );
      this.todoRedirect();
    }
    if (query.up && query.up.length > 0) {
      window.localStorage.setItem("userUnscribe", query.up);
      this.userProfileNavigation();
    }
    this.facebookUrl = `//${config.URL}/api/auth/facebook`;
    this.googleUrl = `//${config.URL}/api/auth/google`;
    this.twitterUrl = `//${config.URL}/api/auth/twitter`;
    this.linkedinUrl = `//${config.URL}/api/auth/linkedin`;
    this.ltseUrl = `//${config.URL}/api/auth/ltse`;

    // this.ltseUrl = `${config.LTSE_URL}?client_id=${config.LTSE_CLIENT_ID}&redirect_uri=${config.LTSE_REDIRECT_URI}&scope=summary&resource=user`
    if (this.$route.query.by) {
      let inviteDetails = this.$route.query;
      localStorage.setItem("invitedBy", JSON.stringify(inviteDetails));
    }
    // attach window message listener
    if (window.addEventListener) {
      window.addEventListener("message", this.handleMessage.bind(this), false);
    } else {
      window.attachEvent("onmessage", this.handleMessage.bind(this));
    }
    // check to see if we can just refresh
    if (this.$store.getters["user/hasToken"]) {
      if (
        !window.localStorage.getItem("share-portfolio-permalink") &&
        !window.localStorage.getItem("plan") &&
        !window.localStorage.getItem("todoEmailPreferencesCheck") &&
        !window.localStorage.getItem("userUnscribe")
      ) {
        this.logout();
      }
    }
    this.flagRequestOnce = false;
  },
  methods: {
    todoRedirect() {
      let self = this;
      let query = self.$route.query;
      if (window.localStorage.getItem("fiifi")) {
        let fiifi = window.localStorage.getItem("fiifi");
        fiifi = JSON.parse(fiifi);
        if (fiifi.user.id && fiifi.user.id.length > 0) {
          self.$store.dispatch("workspace/apiFetchworkspaces").then((data) => {
            let workspaces = this.$store.getters["workspace/workspaces"];
            let currentWorkspace = workspaces.find((item) => {
              if (item.workspace && item.workspace._id == query.w) return item;
            });
            if (currentWorkspace && currentWorkspace._id) {
              var defaultPayload = {
                workspace_title: currentWorkspace.workspace.title,
                workspace_type: currentWorkspace.workspace.type,
                workspace_id: currentWorkspace.workspace._id,
                sectors: currentWorkspace.workspace.sectors,
                stages: currentWorkspace.workspace.stages,
              };
              this.$store.commit("workspace/setDefaultPipeline", {
                payload: defaultPayload,
              });
              this.$store.commit("user/workspace_id", {
                workspace_id: currentWorkspace.workspace._id,
              });
              self.$store.dispatch("dashboardCoordinates/apiFetchCoordinates");
              self.$store
                .dispatch("workspacePlans/getWorkspacePlanFeatures", {
                  workspace_id: currentWorkspace.workspace._id,
                })
                .then((workspacePlans) => {
                  self.$store.dispatch("arbiter/start");
                  window.localStorage.removeItem("todoEmailPreferencesCheck");
                  self.$router.push(
                    `${fiifi.user.id}/${currentWorkspace.workspace._id}/todos?id=${query.t}`
                  );
                });
            } else {
              this.$router.push(`/${fiifi.user.id}/workspace`);
            }
          });
        } else {
          this.$router.push(`/login`);
        }
      }
    },
    userProfileNavigation() {
      let self = this;
      if (window.localStorage.getItem("fiifi")) {
        let fiifi = window.localStorage.getItem("fiifi");
        fiifi = JSON.parse(fiifi);
        let emailUserId = window.localStorage.getItem("userUnscribe");
        if (
          fiifi.user.id &&
          fiifi.user.id.length > 0 &&
          emailUserId == fiifi.user.id
        ) {
          this.$router.push(`/${emailUserId}/profile`);
          window.localStorage.removeItem("userUnscribe");
        } else {
          this.$router.push(`/${fiifi.user.id}/workspace`);
        }
      } else {
        this.$router.push(`/login`);
      }
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    loginCognito(e) {
      e.preventDefault();
      this.isSubmit = true;
      this.showSpinner = true;
      let email = this.loginForm.email.toLowerCase();
      this.$Amplify.Auth.signIn(email, this.loginForm.pswd)
        .then((data) => {
          if (data) {
            let cognitoToken = {
              jwt: data.signInUserSession.getIdToken().jwtToken,
              refreshToken: data.signInUserSession.getRefreshToken().token,
            };
            this.storeCognitoLogin(
              data.signInUserSession.getIdToken().payload,
              cognitoToken
            );
          }
        })
        .catch((err) => {
          console.log("Error", err);
          this.isSubmit = false;
          this.showSpinner = false;
          this.variant = "danger";
          this.message = err.message.includes("radix")
            ? "Incorrect username or password."
            : err.message;
        });
    },
    storeCognitoLogin(data, tokens) {
      api
        .post("/login", { encrypt: { data } })
        .then((res) => {
          this.loginForm = {};
          let user = res.data.encrypt.success.user;
          user.token = res.data.encrypt.success.token;
          user.isNew = res.data.encrypt.success.isNew;
          this.$store.commit("user/token", {
            token: res.data.encrypt.success.token,
          });
          if (user && user.cognito) {
            user.cognito.cognitoToken = tokens;
            this.$store.commit("user/cognito", {
              cognito: user.cognito,
            });
            window.localStorage.setItem("email", user.cognito.email);
          }
          user.email =
            user && user.cognito && user.cognito.email
              ? user.cognito.email
              : "";
          this.$store.commit("user/user", {
            user,
          });
          this.$store.dispatch("arbiter/start");
          this.addAccount(user);

          this.$store.commit(
            "portfolio/setAccountId",
            res.data.encrypt.success.user._id
          );
          //  this.$store.commit("portfolio/setWorkspaceId", payload.workspace_id);
          this.$store.dispatch("notifications/start", null, { root: true });
          this.$store
            .dispatch("accountPlans/getAccountPlanFeatures")
            .then((plans) => {
              this.$store
                .dispatch("workspace/apiFetchworkspaces")
                .then((data) => {
                  self.isSubmit = false;
                  self.showSpinner = false;
                  if (window.localStorage.getItem("userUnscribe")) {
                    this.userProfileNavigation();
                  } else {
                    if (
                      window.localStorage.getItem("todoEmailPreferencesCheck")
                    ) {
                      this.loginTodoRedirect(res.data.encrypt.success.user._id);
                    } else {
                      if (
                        !window.localStorage.getItem(
                          "share-portfolio-permalink"
                        ) &&
                        !window.localStorage.getItem("plan")
                      ) {
                        this.$router.push(
                          `/${res.data.encrypt.success.user._id}/workspace`
                        );
                      } else {
                        if (
                          window.localStorage.getItem(
                            "share-portfolio-permalink"
                          )
                        ) {
                          this.$router.push(
                            `${
                              res.data.encrypt.success.user._id
                            }/shared/company?permalink=${window.localStorage.getItem(
                              "share-portfolio-permalink"
                            )}&back=workspace&a=${window.localStorage.getItem("share-portfolio-referred")}&c=${window.localStorage.getItem("share-portfolio-checklists")}`
                          );
                        }
                        if (window.localStorage.getItem("plan")) {
                          this.$router.push(
                            `${
                              res.data.encrypt.success.user._id
                            }/payments?plan=${window.localStorage.getItem(
                              "plan"
                            )}`
                          );
                        }
                      }
                    }
                  }
                });
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loginTodoRedirect(accountId) {
      let todoEmailPreferencesCheck = JSON.parse(
        window.localStorage.getItem("todoEmailPreferencesCheck")
      );
      let self = this;
      if (accountId == todoEmailPreferencesCheck.a) {
        let workspaces = this.$store.getters["workspace/workspaces"];
        let currentWorkspace = workspaces.find((item) => {
          if (
            item.workspace &&
            item.workspace._id == todoEmailPreferencesCheck.w
          )
            return item;
        });
        if (currentWorkspace && currentWorkspace._id) {
          var defaultPayload = {
            workspace_title: currentWorkspace.workspace.title,
            workspace_type: currentWorkspace.workspace.type,
            workspace_id: currentWorkspace.workspace._id,
            sectors: currentWorkspace.workspace.sectors,
            stages: currentWorkspace.workspace.stages,
          };
          this.$store.commit("workspace/setDefaultPipeline", {
            payload: defaultPayload,
          });
          this.$store.commit("user/workspace_id", {
            workspace_id: currentWorkspace.workspace._id,
          });
          self.$store.dispatch("dashboardCoordinates/apiFetchCoordinates");
          self.$store
            .dispatch("workspacePlans/getWorkspacePlanFeatures", {
              workspace_id: currentWorkspace.workspace._id,
            })
            .then((workspacePlans) => {
              self.$store.dispatch("arbiter/start");
              window.localStorage.removeItem("todoEmailPreferencesCheck");
              self.$router.push(
                `${accountId}/${currentWorkspace.workspace._id}/todos?id=${todoEmailPreferencesCheck.t}`
              );
            });
        } else {
          window.localStorage.removeItem("todoEmailPreferencesCheck");
          this.$router.push(`/${accountId}/workspace`);
        }
      } else {
        window.localStorage.removeItem("todoEmailPreferencesCheck");
        this.$router.push(`/${accountId}/workspace`);
      }
    },
    addAccount(user) {
      let userObj = {
        _id: user._id || user.id,
        workspace_id: user.workspace_id,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.cognito.email,
        user_name: user.cognito.user_name,
      };

      if (window.localStorage.getItem("fiifiUsers")) {
        let users = JSON.parse(window.localStorage.getItem("fiifiUsers"));
        if (users.findIndex((item) => item._id == userObj._id) == -1) {
          window.localStorage.removeItem("fiifiUsers");
          users.push(userObj);
          window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
        }
      } else {
        let users = [];
        users.push(userObj);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
      }
    },
    signup(e) {
      e.preventDefault();
      this.$router.push("/signup");
    },
    handleMessage(event) {
      // check origin
      if (
        _.isNil(event) ||
        _.isEmpty(event) ||
        (event.origin !== "http://localhost:8080" &&
          event.origin !== "http://lvh.me:8080" &&
          event.origin !== "http://fiifi.co" &&
          event.origin !== "https://app.fiifi.co" &&
          event.origin !== "https://app.fiifi-dev.com")
      ) {
        return;
      }
      // check data validity
      if (
        _.isNil(event.data) ||
        _.isEmpty(event.data) ||
        typeof event.data !== "string"
      ) {
        return;
      }
      // parse out the data
      let result = "";
      try {
        result = JSON.parse(event.data);
      } catch (e) {
        // failed to parse, don't want this data
        return;
      }
      // make sure we have field we are expecting
      if (
        _.isNil(result) ||
        _.isEmpty(result) ||
        result.state !== config.LI_STATE
      ) {
        return;
      }

      // for some reason, we are getting this called 3-4x per login attempt, adding in a flag until can figure out why
      if (this.flagRequestOnce) return;
      this.flagRequestOnce = !this.flagRequestOnce && !result.error;

      if (result.error) {
        // error return
        console.log(`Error return: ${result.error} : ${result.description}`);
        this.loginFail();
      } else if (result.code) {
        // successful return, can't send code to our server -- retrieve token here instead
        return this.$store
          .dispatch("user/apiConfirmLI", result.code)
          .then((data) => {
            this.loginSuccess(data);
          })
          .catch((err) => {
            console.log(`Error in login.vue from api return ${err}`);
            this.loginFail();
          });
      }
    },
    loginFail() {
      swal({
        title: "Login Failed",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-danger btn-fill",
        text:
          "Please verify your login credentials and try again. (You may need to log out of LinkedIn's website.",
      });
      this.$router.push("#/login");
    },
    logout() {
      // if (!this.$route.query.redirect) {
      //   swal({
      //     title: "Log Out",
      //     text: "You have been successfully logged out."
      //   });
      // }
      window.sessionStorage.clear();
      this.$store.dispatch("arbiter/shutdown");
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    checkValidations() {
      this.message = "";
      this.isSubmit =
        this.loginForm.pswd &&
        this.loginForm.pswd.length > 0 &&
        this.loginForm.email &&
        this.loginForm.email.length > 0
          ? false
          : true;
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style >
.ltseBtnDiv {
  width: 40px;
  height: 40px;
  background: #030e25 0% 0% no-repeat padding-box;
  border-radius: 50%;
}
@media (max-width: 576px) {
  .trnsCls {
    width: none !important;
  }
}

@media (min-width: 768px) and (max-width: 960px) {
  .mrgnTpCls {
    margin-top: 10% !important;
  }
  .heading {
    margin-top: 6% !important;
  }
}

@media (max-width: 768px) {
  .bckGrdImg {
    background-image: none !important;
  }
}

@media (min-width: 1200px) {
}
.mrgnTpCls {
  margin-top: 5%;
}
body,
.wrapper {
  min-height: 0vh !important;
  position: relative;
}
.heading {
  color: #fff;
  font-size: 36px;
  font-family: Comfortaa, cursive;
  /* padding-left: 56px; */
  opacity: 1;
  /* margin-left: 3%;
  margin-top: 3%; */
}
.bckGrdImg {
  width: 100%;
  margin-top: 1%;
  background-image: url("../../../../public/static/img/login-img.png");
  background-repeat: no-repeat;
  background-position: 50% 0px;
  margin-bottom: -1%;
  height: calc(100vh - 121px);
}
.trnsCls {
  background: no-repeat padding-box white;
  box-shadow: 0 0 20px #2455996f;
  border-radius: 10px;
  transition: all 0.5s ease;
  width: 355px;
  padding: 30px;
  /* margin: auto; */
  /* height: 400px; */
}

.wlcmTxt {
  margin-top: 0px;
  text-align: left;
  font: Regular 36px/43px Helvetica Neue;
}

.tag {
  color: #2e2e2e;
  font-size: 14px;
  text-align: left;
  width: 100%;
  font: Medium 14px/20px Helvetica Neue;
  letter-spacing: 0;
  color: #2e2e2e;
  opacity: 1;
}

.forgtTxt {
  margin-top: 4px;
  font-size: 12px;
  font: Medium 12px/15px Helvetica Neue;
  opacity: 1;
}

.lgnBtn {
  font-size: 14px;
  color: white;
  width: 100%;
  height: 38px;
  background: #5445f3 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #5445f367;
  border: 1px solid #5445f3;
  border-radius: 5px;
  opacity: 1;
}

.crtAcntBtn {
  font-size: 14px;
  width: 100%;
  height: 38px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000029;
  border-radius: 5px;
  opacity: 1;
}

.lgnIcns {
  margin-right: 9px;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #000;
}
.separator::before {
  margin-right: 0.25em;
}
.separator::after {
  margin-left: 0.25em;
}
.loginBackgroundImage {
  background-image: url("../../../../public/static/img/login-bg.svg");
  background-size: cover;
}

.loginPopup {
  width: 400px;
  /* height: 527px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #000000aa;
  border-radius: 5px;
  opacity: 1;
}

.loginPopupLayout {
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 50px;
  padding-right: 50px;
}

.emailWrapper input[type="text"] {
  position: relative;
  margin-bottom: 28px;
}

.emailWrapper input[type="text"]:before {
  font-family: "FontAwesome";
  position: absolute;
  top: 0px;
  left: -5px;
  content: "\f0e0";
}
.inputLoginWrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000000;
  border: 1px solid #2e2e2e !important;
  border-radius: 5px;
  opacity: 1;
  background-image: url("../../../../public/static/img/email-icon.png");
  background-position: 10px 12px;
  background-repeat: no-repeat;
  padding-left: 35px;
  background-size: 15px;
}
.inputLoginWrapper:focus {
  border: 1px solid #5445f3 !important;
}
</style>
<style scoped>
input[type="password"] {
  background-image: url("../../../../public/static/img/password-icon.png");
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding-left: 35px;
  background-size: 15px;
}
.inputLoginWrapper input[type="text"] {
  background-image: url("../../../../public/static/img/email-icon.png");
  background-position: 8px 10px;
  background-repeat: no-repeat;
  padding-left: 35px;
}
</style>